<template>
    <PopoverRight ref="popoverMenu" width="550px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">{{title}}广告页面</h1>
            <el-form class="form-container" :model="pageInfo" :rules="pageRules" ref="pageInfo">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">页面名称</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="name">
                            <el-input placeholder="请输入页面名称"  v-model="pageInfo.name">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">客户端</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="terminal_id">
                          <el-select v-model="pageInfo.terminal_id">
                                <el-option
                                    v-for="(item, key) in terminals"
                                    :value="item.id"
                                    :label="item.name"
                                    :key="key"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-button">
                    <el-button type="primary" @click="submitForm('pageInfo')">确 认</el-button>
                    <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>

<script>
    import {createPage,changePage } from "@/service/ad";
    import PopoverRight from '@/components/popoverRight/index'
    export default {
        name: "add",
        components: {
            PopoverRight
        },
        props: {
            callback: Function,
        },
        data () {
            return {
                title:'',
                pageInfo: {
                    name: '',
                    terminal_id: '',
                    terminal_name:''
                },
                terminals:null,

                pageRules: {
                    name: [
                        { required: true, message: '请填写页面名称', trigger: 'blur' },
                        { min: 1, max: 16, message: '长度在 1 到 16个字符', trigger: 'blur' }
                    ],
                    terminal_id: [
                      {required: true, message: "请选择客户端", trigger: "change" }
                    ],
                },
            }
        },
        methods : {
            async open () {
                this.$refs.pageInfo && this.$refs.pageInfo.clearValidate()
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
            },
            /** 关闭右侧悬浮层 */
            hide () {
                this.resetForm();
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
                this.$refs.pageInfo && this.$refs.pageInfo.clearValidate()
            },
            resetForm () {
                this.pageInfo = {
                    id:'',
                    name: '',
                    terminal_id: '',
                    terminal_name:''
                }
            },
            submitForm (formName) {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                           this.pageInfo.terminal_name=this.terminals.find(ele => ele.id === this.pageInfo.terminal_id).name;
                       if(this.title=="新增"){
                            createPage(this.pageInfo).then((data) => {
                            this.$message({
                                message: '添加成功',
                                type: 'success',
                                duration: 3 * 1000
                            })
                            this.resetForm()
                            this.hide()
                            this.callback && this.callback()
                        }).catch(err => {
                            const message = err.context ? err.context[0] : err.message
                            this.$message({
                                message: message || '添加失败',
                                type: 'error',
                                duration: 3 * 1000
                            })
                        })
                       }else{
                            changePage(this.pageInfo.id,this.pageInfo).then((data) => {
                            this.$message({
                                message: '修改成功',
                                type: 'success',
                                duration: 3 * 1000
                            })
                            this.resetForm()
                            this.hide()
                            this.callback && this.callback()
                        }).catch(err => {
                            const message = err.context ? err.context[0] : err.message
                            this.$message({
                                message: message || '添加失败',
                                type: 'error',
                                duration: 3 * 1000
                            })
                        })
                       }
                      

                    } else {
                        return false
                    }
                })
            },
        },
    }
</script>

<style scoped>

</style>
